// extracted by mini-css-extract-plugin
export var linkText = "_mf-0";